<header class="navbar navbar-fixed-top bg-system">
    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/" ng-click="mainPage()">
                <img src="img/logo-blue.svg" alt="Hodxpress.com">
            </a>
        </li>
    </ul>

    <ul class="nav navbar-nav navbar-center">
    </ul>

    <ul class="nav navbar-nav navbar-right">

        <div class="btn-group pull-right">
            <!-- <a href="/musteri-yonetimi-map" 
                class="hod-button outline ml10">
                Map
            </a> -->
            <!-- <a href="#" 
                class="hod-button blue ml10" 
                ng-click="downloadExcel()" 
                ng-disabled="selectedItem.length == 0"> 
                Export Excel
            </a> -->
            <a href="#" 
                ng-click="newData()"
                class="hod-button blue ml10"> 
                New Partner
            </a>
        </div>

    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActiveCustomer(['/musteri-yonetimi/','/musteri-yonetimi-map/'])">
        
    <ul class="nav navbar-nav navbar-left">

        <input 
            type="text" 
            ng-model="filterData.customer_name" 
            class="btn btn-operation ml10 w200" 
            placeholder="By Partner Name">

        <!--
            
        <input 
            type="text" 
            ng-model="filterData.phone_number" 
            class="btn btn-operation ml10" 
            placeholder="Telefon Numarası" >

        <input 
            type="text" 
            ng-model="filterData.address" 
            class="btn btn-operation ml10" 
            placeholder="Adres" >
        
        <input 
            type="text" 
            ng-model="filterData.city" 
            class="btn btn-operation ml10" 
            placeholder="İl" >
            
        <input 
            type="text" 
            ng-model="filterData.district" 
            class="btn btn-operation ml10" 
            placeholder="İlçe" >
        -->

        <!-- <select class="ml10 selectpicker" 
            multiple 
            title="Renk"
            data-live-search="false" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.color"
            data-style="btn-primary">
            <option ng-repeat="item in colorList" data-select-watcher data-last="{{$last}}" value="{{item}}" ng-style="{'background-color': item }" style="padding:10px 5px;margin:3px">
            </option>
        </select> -->

        <!--
            
        <li class="dropdown dropdown-fuse hidden-xs">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                <span class="fa fa-chevron-down"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-form p10 w200" role="menu">
                <li ng-repeat="item in data.fields">
                    <a href="#" ng-if="filterProp.indexOf(item.id) < 0" ng-click="addFilterProps(item.id)">{{ item.name }}</a>
                </li>
            </ul>
        </li>

        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="filterData.term" 
            placeholder="Müşteri Ara">

        -->

        <a href="#" 
            class="btn w50 p-2 ml10" 
            ng-click="refreshData('customer_list')" 
            style="line-height: 20px;"
            ng-show="filterData.customer_name">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" 
            class="clear-filter ml-3" 
            ng-click="filter('clear')" 
            style="line-height: 20px;"
            ng-show="filterData.customer_name">
            Clear Filter
        </a>

        <!-- <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('all')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Tümünü Sil
        </a> -->

    </ul>
    
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActiveCustomer(['/musteri-yonetimi/ozel-alanlar/'])">
        
    <ul class="nav navbar-nav navbar-left">

        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="Özel Alan Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Sil
        </a>
    </ul>
    

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="/musteri-yonetimi/ozel-alanlar/yeni" class="btn btn-warning btn-rounded">
                Müşteri Özel Alan Ekle
            </a>
        </li>

    </ul>
    
</header>
